const $ = require('jquery');
const forEach = require('lodash.foreach');
require('chosen-js');

const name = getQueryVariable('name');
// const email = getQueryVariable('email');

if (name) {
  $('#name').text(`, ${name}`);
} else {
  $('#name').remove();
}

if ($('.js-redirect').length) {
  populateRedirectButton();
}

function getQueryVariable(variable) {
  const query = window.location.search.substring(1);
  const vars = query.split('&');
  for (let i = 0; i < vars.length; i += 1) {
    const pair = vars[i].split('=');
    if (pair[0] === variable) {
      return decodeURIComponent(pair[1]);
    }
  }
  return false;
}

// swap standard error messages for custom ones
// clientside validation doesn't use the custom messages,
// so we update the default message data attribute to the
// custom one
const $fields = $('[data-webform-required-error]');

forEach($fields, item => {
  const realErrorMsg = item.dataset.webformRequiredError;
  item.dataset.msgRequired = realErrorMsg;
});

// add in * for required fields since webform doesn't like to add them
const $allInputs = $('[required], [required="true"]');

forEach($allInputs, item => {
  if ($(item).is('input')) {
    $(item).siblings('label').not('.error').append('<span class="required-mark">*</span>');
  }

  if ($(item).is('textarea')) {
    $(item).parent().siblings('label').not('.error').append('<span class="required-mark">*</span>');
  }
});

function populateRedirectButton() {
  const url = getQueryVariable('redirect');
  const title = getQueryVariable('title');
  console.log(`${url}\n${title}`)
  if (url && title) {
    $('.js-redirect').attr('href', url).html(`Return to ${title}`).removeClass('button');
  }
}

function getParameterByName(name, url) {
  if (!url) url = decodeURIComponent(window.location.href);
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}


// make the select on the homepage fancy
$('.select-industry select').chosen({
  disable_search: true,
});

// hijack homepage form
$('.select-industry').on('submit', e => {
  e.preventDefault();
  const url = $('.select-industry select').find(":selected")[0].dataset.url;
  if (url !== undefined) {
    window.location.href = url;
  }
});

// fill out who form should be emailed to on property pages
if (window.EMAIL_FORM_TO) {
  $('input[data-drupal-selector="edit-send-form-to"]').val(window.EMAIL_FORM_TO);
}

// some property titles have & in them, we need to encode that
if ($('input[name="property_title"]').length) {
  const currentVal = $('input[name="property_title"]').val();
  const safeVal = encodeURIComponent(currentVal);
  $('input[name="property_title"]')[0].value = safeVal;
}
